import { combineReducers } from 'redux';

import abacus from './modules/abacus';
import content from './modules/content';
import intl from './modules/intl';
import renderOptions from './modules/renderOptions';
import scratchpad from './modules/scratchpad';
import system from './modules/system';
import user from './modules/user';
import login from './modules/login';

export default combineReducers({
  abacus,
  content,
  intl,
  renderOptions,
  scratchpad,
  system,
  user,
  login
});



// WEBPACK FOOTER //
// ./src/universal/redux/reducer.js